import React, { useState, useEffect, useContext } from "react";
import { WhiteButton, SecondaryButton } from "../../../main_portal/components/common_components/Buttons";
import Modal from "../../../main_portal/components/common_components/Modal";
import YCIcon from "../../../../../../assets/images/researcher_app/create/create_your_community.png";
import LightbulbIcon from "../../../../../../assets/images/researcher_app/create/create_other_formats.png";
import XIcon from "../../../../../../assets/images/researcher_app/create/x_button.svg";
import WarningIcon from "../../../../../../assets/images/researcher_app/overview/shield_warning_icon.svg";



function PurpleYourCommunityModal(props) {
    const style = {
        maxWidth: "350px",
        gap: "32px"
    }

    return (
        <Modal toggleModal={props.toggleModal} isOpen={props.isOpen} closeable={false} backgroundColor="dark">
            <PurpleCard style={style}>
                <button className="modal-close-button" onClick={props.toggleModal}>
                    <img src={XIcon} height={24} width={24} />
                </button>
                <div className="purple-modal-content">
                    <img src={YCIcon} />
                    <div className="purple-modal-text-container">
                        <div className="purple-modal-title">
                            Your Community
                        </div>
                        <div className="purple-modal-text-and-subtext">
                            <div className="purple-modal-text">
                                Despark needs to set these missions up for you currently.
                            </div>
                            <div className="purple-modal-text">
                                Contact us at <span style={{ fontWeight: 600 }} >info@despark.io</span>. to learn more or select User Pool
                                to launch a project immediately.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="purple-modal-button-container">
                    <WhiteButton text="Close" onClick={props.toggleModal} />
                </div>
            </PurpleCard>
        </Modal>
    )

}
function PurpleOtherFormatsModal(props) {
    const style = {
        maxWidth: "350px",
        gap: "32px"
    }

    return (
        <Modal toggleModal={props.toggleModal} isOpen={props.isOpen} closeable={false} backgroundColor="dark">
            <PurpleCard style={style}>
                <button className="modal-close-button" onClick={props.toggleModal}>
                    <img src={XIcon} height={24} width={24} />
                </button>
                <div className="purple-modal-content">
                    <img src={LightbulbIcon} height={48} width={48} />
                    <div className="purple-modal-text-container">
                        <div className="purple-modal-title">
                            Other Formats
                        </div>
                        <div className="purple-modal-text-and-subtext">
                            <div className="purple-modal-text">
                                We support a variety of other formats that can't yet be created on our portal.
                            </div>
                            <div className="purple-modal-text">
                                Contact us at <span style={{ fontWeight: 600 }} >info@despark.io</span> to learn more.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="purple-modal-button-container">
                    <WhiteButton text="Close" onClick={props.toggleModal} />
                </div>
            </PurpleCard>
        </Modal>
    )

}


function PurpleMissionLiveWarningModal(props) {
    const style = {
        maxWidth: "550px",
        gap: "32px"
    }

    return (
        <Modal toggleModal={props.toggleModal} isOpen={props.isOpen} closeable={false} backgroundColor="dark">
            <PurpleCard newStyle={style}>
                <button className="modal-close-button" onClick={props.toggleModal}>
                    <img src={XIcon} height={24} width={24} />
                </button>
                <div className="purple-modal-content">
                    <img src={WarningIcon} height={48} width={48} />
                    <div className="purple-modal-text-container">
                        <div className="purple-modal-title">
                            Warning: data may be lost
                        </div>
                        <div className="purple-modal-text-and-subtext large-gap">
                            <div className="purple-modal-text">
                                Modifying a live survey may delete already collected responses. Deleting questions or choices will remove all existing data associated with them.
                            </div>
                            <div className="purple-modal-text">
                                Adjusting a live survey will update your price per response.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="purple-modal-equal-button-container">
                    <SecondaryButton text="Cancel" onClick={props.onCancel} style={{ flexGrow: 1 }} />
                    <WhiteButton text="I understand" onClick={props.toggleModal} style={{ flexGrow: 1 }} />
                </div>
            </PurpleCard>
        </Modal>
    )

}

function PurpleMissionLiveRequirementsWarningModal(props) {
    const style = {
        maxWidth: "550px",
        gap: "32px"
    }

    return (
        <Modal toggleModal={props.toggleModal} isOpen={props.isOpen} closeable={false} backgroundColor="dark">
            <PurpleCard newStyle={style}>
                <button className="modal-close-button" onClick={props.toggleModal}>
                    <img src={XIcon} height={24} width={24} />
                </button>
                <div className="purple-modal-content">
                    <img src={WarningIcon} height={48} width={48} />
                    <div className="purple-modal-text-container">
                        <div className="purple-modal-title">
                            Edits may change pricing
                        </div>
                        <div className="purple-modal-text-and-subtext large-gap">
                            <div className="purple-modal-text">
                                Editing audience requirements will immediately update your price per response.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="purple-modal-equal-button-container">
                    <SecondaryButton text="Cancel" onClick={props.onCancel} style={{ flexGrow: 1 }} />
                    <WhiteButton text="I understand" onClick={props.toggleModal} style={{ flexGrow: 1 }} />
                </div>
            </PurpleCard>
        </Modal>
    )

}

function PurpleCard(props) {
    return (
        <div className="purple-modal-card">
            {props.children}
        </div>
    )
}

export { PurpleYourCommunityModal, PurpleOtherFormatsModal, PurpleMissionLiveWarningModal, PurpleMissionLiveRequirementsWarningModal }